import { Link } from "react-router-dom";
import { useEffect } from "react";
import Footer from "../components/Footer";

const Cocons2025Valouse = () => {
  // SEO meta tags - optimisés pour retraite spirituelle Drôme
  useEffect(() => {
    document.title = "COCON Valouse 2025 | Retraite spirituelle Drôme - Cycle initiatique";
    
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "COCON Valouse 2025 : cycle initiatique contemporain en Drôme provençale. 5 jours d'immersion en Hameau privatisé. Retraite transformation France petit groupe.");
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F2E8] text-[#4A5240]">
      {/* Header */}
      <header className="px-6 pt-8 pb-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <a
            href="/#retraite-cocon-2025"
            className="text-sm text-[#6B7B5C] hover:text-[#4A5240] transition-colors"
          >
            ← Retour à l'accueil
          </a>
          <p className="text-xs tracking-[0.25em] uppercase text-[#6B7B5C]">
            Valouse · 2025
          </p>
        </div>
      </header>

      {/* Hero - Logo */}
      <section className="px-6 py-6">
        <div className="max-w-sm mx-auto">
          <img
            src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/xga56uzq_Cocon.jpg"
            alt="COCON – Retraite spirituelle Drôme provençale"
            className="w-full h-auto"
          />
        </div>
      </section>

      {/* Titre principal + Accroche distincte */}
      <section className="px-6 py-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-lg md:text-xl tracking-[0.2em] uppercase font-medium text-[#4A5240] mb-8">
            COCON Valouse 2025
          </h1>
          
          {/* Bloc accroche - visuellement distinct */}
          <div className="border-t border-b border-[#6B7B5C]/30 py-8 my-6">
            <p className="text-base md:text-lg leading-relaxed text-[#4A5240]">
              COCON Valouse 2025 n'a pas été une retraite.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-[#4A5240] mt-2">
              C'était un <span className="italic">cycle initiatique contemporain</span>, vécu en Drôme provençale.
            </p>
            <p className="text-sm text-[#6B7B5C] mt-6 tracking-wide">
              Avant. Pendant. Après.
            </p>
            <p className="text-sm text-[#6B7B5C] tracking-wide">
              Un processus complet.
            </p>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* AVANT — PRÉ-COCON */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      <section className="py-12 px-6 bg-[#E8E5D8]">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-sm tracking-[0.3em] uppercase font-medium text-[#6B7B5C] text-center mb-2">
            Avant
          </h2>
          <p className="text-xs tracking-[0.2em] uppercase text-[#5A6650] text-center mb-10">
            Pré-COCON · Préparation en ligne
          </p>

          {/* PDF - Un message pour raviver ce qui sommeille */}
          <div className="text-center mb-10">
            <a
              href="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/k85jplks_COCON%20%7C%2013%20juillet%20%E2%80%93%20Un%20message%20pour%20raviver%20ce%20qui%20sommeille.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-[#6B7B5C]/10 border border-[#6B7B5C]/30 text-[#4A5240] text-sm hover:bg-[#6B7B5C]/20 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              Un message pour raviver ce qui sommeille
            </a>
          </div>

          {/* Cercle Zoom - Photo + Vidéo + Photo sur la même ligne */}
          <p className="text-xs tracking-[0.15em] uppercase text-[#6B7B5C] text-center mb-4">
            Extrait · Ouverture du premier cercle
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch">
            {/* Photo 1 */}
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/f7j2jfi5_Screenshot%202024-10-03%20at%2023.02.21.png" 
                alt="Préparation en ligne retraite transformation France"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Vidéo */}
            <div className="rounded-xl overflow-hidden shadow-lg">
              <video 
                controls 
                className="w-full h-full object-cover"
                preload="metadata"
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/67g4fiba_7.7%20Ouverture%20du%20Call.mp4" 
                  type="video/mp4" 
                />
              </video>
            </div>
            {/* Photo 2 */}
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/fnz250np_Screenshot%202024-10-03%20at%2023.03.10.png" 
                alt="Cercle préparation retraite immersive petit groupe"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* PENDANT — IMMERSION */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      <section className="py-12 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-sm tracking-[0.3em] uppercase font-medium text-[#6B7B5C] text-center mb-2">
            Pendant
          </h2>
          <p className="text-xs tracking-[0.2em] uppercase text-[#5A6650] text-center mb-4">
            Immersion · Hameau de Valouse
          </p>
          <p className="text-xs text-[#6B7B5C] text-center mb-8 italic">
            Photographies : Kilian Fermond
          </p>

          {/* Bloc explicatif sur les images */}
          <div className="max-w-2xl mx-auto mb-10 text-center border-l-2 border-[#6B7B5C]/30 pl-6 py-2">
            <p className="text-sm text-[#4A5240] mb-4">
              Certaines images présentées ici portent encore le sceau de notre photographe, Kilian Fermond.
            </p>
            <p className="text-sm text-[#5A6650] italic mb-4">
              Elles ne sont pas des visuels lissés.<br />
              Elles sont des fragments bruts.
            </p>
            <p className="text-sm text-[#5A6650] mb-4">
              Comme des planches-contact.<br />
              Des instants saisis avant toute sélection.<br />
              Des images encore non dévoilées.
            </p>
            <p className="text-sm text-[#4A5240]">
              Vous découvrez ici l'envers du décor.<br />
              L'accès backstage.<br />
              La matière vivante d'un cycle en train de se vivre.
            </p>
          </div>

          {/* Carrousel photos - 4 visibles à la fois, défilement modéré */}
          <div className="overflow-hidden">
            <style>{`
              @keyframes gallery-pendant-scroll {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
              .gallery-pendant-track {
                animation: gallery-pendant-scroll 70s linear infinite;
              }
              .gallery-pendant-track:hover {
                animation-play-state: paused;
              }
            `}</style>
            <div className="gallery-pendant-track flex gap-3" style={{ width: 'max-content' }}>
              {/* Photos set 1 */}
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/08j0yyka_DSC03646.jpg" 
                  alt="Célébration groupe retraite spirituelle Drôme"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/62op6xj1_DSC00830%20%281%29.jpg" 
                  alt="Atelier dessin intuitif retraite"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/k72ri5k6_DSC04044.jpg" 
                  alt="Cercle de parole Hameau privatisé"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/co1p3k6s_DSC00929.jpg" 
                  alt="Enseignement atelier transformation"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/cealjs9e_DSC04071.jpg" 
                  alt="Retraite immersive petit groupe France"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/yhnihdhb_DSC01363.jpg" 
                  alt="Cérémonie tambour nature"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/7n2ku77e_DSC04612.jpg" 
                  alt="Danse libération transformation"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/cnxohhm9_DSC01515.jpg" 
                  alt="Soin énergétique balcon nature"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/0obbz4xm_DSC03074.jpg" 
                  alt="Terrasse Hameau Drôme provençale"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/iz7bhxv8_DSC02077.jpg" 
                  alt="Outils sacrés cartes oracle"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/w43cpv54_DSC02009.jpg" 
                  alt="Méditation contemplative retraite"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/1xsprjvo_DSC00670%20%281%29.jpg" 
                  alt="Objets sacrés autel retraite"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/azbcopyu_DSC03940.jpg" 
                  alt="Atelier écriture cercle"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/lifx5bhk_DSC04434.jpg" 
                  alt="Portrait participante retraite spirituelle"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Duplication pour boucle infinie */}
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/08j0yyka_DSC03646.jpg" 
                  alt="Célébration groupe retraite"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/62op6xj1_DSC00830%20%281%29.jpg" 
                  alt="Atelier dessin intuitif"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/k72ri5k6_DSC04044.jpg" 
                  alt="Cercle de parole"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/co1p3k6s_DSC00929.jpg" 
                  alt="Enseignement atelier"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/cealjs9e_DSC04071.jpg" 
                  alt="Retraite immersive"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/yhnihdhb_DSC01363.jpg" 
                  alt="Cérémonie tambour"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/7n2ku77e_DSC04612.jpg" 
                  alt="Danse libération"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/cnxohhm9_DSC01515.jpg" 
                  alt="Soin énergétique"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/0obbz4xm_DSC03074.jpg" 
                  alt="Terrasse Hameau"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/iz7bhxv8_DSC02077.jpg" 
                  alt="Outils sacrés"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/w43cpv54_DSC02009.jpg" 
                  alt="Méditation contemplative"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/1xsprjvo_DSC00670%20%281%29.jpg" 
                  alt="Objets sacrés autel"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/azbcopyu_DSC03940.jpg" 
                  alt="Atelier écriture"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-shrink-0 w-64 h-64 rounded-lg overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a9e4b3eb-6cf0-46b7-85a6-000614fbaf25/artifacts/lifx5bhk_DSC04434.jpg" 
                  alt="Portrait participante"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* APRÈS — POST-COCON */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      <section className="py-12 px-6 bg-[#E8E5D8]">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-sm tracking-[0.3em] uppercase font-medium text-[#6B7B5C] text-center mb-2">
            Après
          </h2>
          <p className="text-xs tracking-[0.2em] uppercase text-[#5A6650] text-center mb-10">
            Post-COCON · Intégration
          </p>

          <div className="space-y-6">
            {/* Capsule PDF */}
            <a
              href="https://customer-assets.emergentagent.com/job_f4b70bfc-5042-482e-b831-1758c1c63edc/artifacts/3klv0wkp_Capsule%20post-Cocon%20n%C2%B01%20%E2%80%93%20Le%20rappel%20de%20ton%20pouvoir.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center px-5 py-4 rounded-lg bg-[#6B7B5C]/10 border border-[#6B7B5C]/30 text-[#4A5240] hover:bg-[#6B7B5C]/20 transition-colors"
            >
              <div className="flex items-center justify-center gap-2 mb-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                </svg>
                <span className="text-sm">Capsule n°1 · Le rappel de ton pouvoir</span>
              </div>
            </a>

            {/* Méditation audio */}
            <div className="text-center px-5 py-4 rounded-lg bg-[#6B7B5C]/10 border border-[#6B7B5C]/30">
              <div className="flex items-center justify-center gap-2 mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4A5240" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18V5l12-2v13"/>
                  <circle cx="6" cy="18" r="3"/>
                  <circle cx="18" cy="16" r="3"/>
                </svg>
                <span className="text-sm text-[#4A5240]">Le Feu de la Clarté · Paroles vivantes par Jeinar</span>
              </div>
              <audio 
                controls 
                className="w-full max-w-md mx-auto"
                preload="metadata"
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_b2472d9f-7229-4306-b190-d947a8bab60d/artifacts/p2xi8xoe_%F0%9F%8E%A7%20Le%20Feu%20de%20la%20Clarte%CC%81%20%E2%80%94%20Paroles%20vivantes%20par%281%29.MP3" 
                  type="audio/mpeg" 
                />
              </audio>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* BLOC SYNTHÈSE */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      <section className="py-14 px-6">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-xs tracking-[0.2em] uppercase text-[#6B7B5C] mb-8">
            Ce cycle a inclus
          </p>
          
          <div className="space-y-3 mb-10">
            <p className="text-sm text-[#4A5240] flex items-center justify-center gap-2">
              <span className="text-[#6B7B5C]">✓</span> 9 rendez-vous de préparation en ligne
            </p>
            <p className="text-sm text-[#4A5240] flex items-center justify-center gap-2">
              <span className="text-[#6B7B5C]">✓</span> 5 jours d'immersion en Hameau privatisé
            </p>
            <p className="text-sm text-[#4A5240] flex items-center justify-center gap-2">
              <span className="text-[#6B7B5C]">✓</span> 9 rendez-vous d'intégration
            </p>
            <p className="text-sm text-[#4A5240] flex items-center justify-center gap-2">
              <span className="text-[#6B7B5C]">✓</span> 46% des coconé·e·s de l'édition 2024 revenu·e·s
            </p>
          </div>

          <div className="border-t border-[#6B7B5C]/30 pt-8">
            <p className="text-base text-[#4A5240] font-medium">
              COCON est un processus.
            </p>
            <p className="text-sm text-[#6B7B5C] mt-1">
              Pas un événement isolé.
            </p>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* BOUTON FINAL UNIQUE */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      <section className="py-12 px-6 bg-[#E8E5D8]">
        <div className="max-w-3xl mx-auto text-center">
          <Link
            to="/valouse"
            className="inline-flex items-center justify-center px-10 py-4 rounded-full bg-[#6B7B5C] text-[#F5F2E8] text-sm tracking-[0.18em] uppercase shadow-md hover:bg-[#4A5240] transition-colors duration-300"
            data-testid="cta-valouse-2026"
          >
            Découvrir COCON Valouse 2026
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Cocons2025Valouse;
